


















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import {
  getFlowConfig,
  getFlowDetail,
  saveDraftDetail,
  saveFlowDetail,
  getFenqunAvailableList,
  copyFlowDetail,
  sendTestEmail,
  getSuggestList,
  getToken,
  savePublishDetail,
  saveCompanyTemplate,
  getFlowStatistics,
  getCompanyDetail,
  exportDataToEmail,
  downloadTimes,
  getQueryVariable
} from "@/services/api";
import { FlowConfigVO, ShowVO } from "@/model/FlowConfigVO";
import YcHeader from "@/components/common/yc-header.vue";
import YcAside from "@/components/common/yc-aside.vue";
import FlowBox from "@/components/flow/flow-box.vue";
import {
  FlowDetailVO,
  RuleFilterVO,
  StrategyUnitVO,
} from "@/model/FlowDetailVO";
import Drawer from "@/components/flow/drawer.vue";
import FlowRelation from "@/components/flow/flow-relation.vue";
import store from "@/store";
import {getConfigTips, tagList, tagRegStr} from "@/services/config";
import { getPickerOptions, dateFormat, DateDiff, getWeekFirstDay, throttle } from "@/services/common";
import TextEditor from "@/components/flow/text-editor.vue";
import ShortMessageEditor from "@/components/flow/short-message-editor/index.vue";
import {getSegmentInfo} from '@/components/flow/short-message-editor/segementTools'
import moment from "moment";

@Component({
  components: {
    "yc-aside": YcAside,
    "yc-header": YcHeader,
    "yc-flow-box": FlowBox,
    "yc-drawer": Drawer,
    'text-editor': TextEditor,
    'yc-flow-relation': FlowRelation,
    "short-message-editor": ShortMessageEditor,
  },
  methods: {
      handleModalSubmit: throttle(async function () {
        this.$refs.emailFrom.validate(vaild => {
          if (vaild) {
            downloadTimes({
              type: 1,
              businessId: `${this.flowDetail.id}`,
            }).then(res => {
              if (res?.data?.message === 'success' && res?.data?.data >= 4) {
                this.$message.warning('导出数据出现异常？可联系客服人员协助解决')
              }
            })

            let strategyIds = this?.flowDetail && this?.flowDetail.strategyUnitList.map(item => item.id)

            exportDataToEmail({
              strategyIds,
              dateStart: this.date[0],
              dateEnd: this.date[1],
              receiverEmail: this.modalFrom.email,
              flowId: this.flowDetail.id,
            }).then(res => {
              if (res?.status === 200) {
                this.exportWait = true
              } else {
                this.$message.error('数据导出失败，请重试');
              }
            })
          }
        })
    }, 3000),
}
}
)

export default class StrategyFlow extends Vue {
  // 邮件模板控制
  public showTemplate = false;
  public showSelectTemplate = false;
  public activeStyleId = 1;
  public smsEditorVisible = false;

  public easyEmailSrc = '';
  public showEasyEmail = false;
  public emailExpandVisible = false;
  public permission = '';

  // 进入设置显示控制
  public settingVisible = false;
  // 进入策略详情显示控制
  public strategyDetailStatus = "";
  // 当前策略详情
  public activeStrategyUnit: StrategyUnitVO = {};

  // 控制进入设置tab切换
  public activeTab = 1;

  public userRule = `{"relation": "AND","windowDo": "DO","window": {},"rules":[{"type":"EVENT","relation":"AND","strictType": "PROPERTY_STRICT","filters":[]},{"type":"RELATION","strictType": "ACTION_STRICT","relation":"AND","rules":[]}]}`;
  public eventRule = `{"relation": "OR","windowDo": "DO","window": {"value": "1","unit":"DAY"},"rules":[{"type":"EVENT","eventName":"","relation":"AND","filters":[]}]}`;

  public config: FlowConfigVO | null = null;
  public flowDetail: FlowDetailVO | null = null;
  public fenqunList: { en: number; show: string }[] = [];

  public rules: any = {
    name: [
      { required: true, message: "流程名称不能为空", trigger: "blur" },
      { max: 60, message: "流程名称不能超过60个字符", trigger: "blur" },
    ],
    cname: [
      { required: true, message: "策略名称不能为空", trigger: "blur" },
      { max: 60, message: "策略名称不能超过60个字符", trigger: "blur" },
    ],
    subject: [
      { required: true, message: "邮件主题不能为空", trigger: "blur" },
      // { max: 60, message: "邮件主题不能超过60个字符", trigger: "blur" },
    ],
    "delayConfig.value": [
      {
        type: "number",
        required: true,
        message: "延迟时间不能为空",
        trigger: "blur",
      },
    ],
    email: [
      {
        trigger: "change",
        validator: (rule: any, value: any, callback: any) => {
          // 限制中文和空格的输入且只允许输入40个字符
          this.modalFrom.email = value.replace(/[\u4E00-\u9FA5 ]/g, '').slice(0, 40)
          if (!(new RegExp("[\\w!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?")).test(value)) {
            callback(new Error("请输入正确的邮箱地址"));
          } else {
            callback();
          }
        },
      },
      { required: true, message: '请输入邮箱地址', trigger: 'blur' },
    ]
  };

  emailInterval = 0

  get strategyChannelList() {
    return [{en:'Email',show:'邮件营销'},{en:'Sms',show:'短信营销'}];
  }
  getSegmentInfo(value: string) {
    return getSegmentInfo(value);
  }
  /**
   * V.C Add items
   */
  // 是否点击第二步的下一步进行验证触发器状态permission
  public strategyStatus: boolean = false;

  //明细热区数据
  FlowStatistics :null | any[] = null

  // 初始默认选中本周
  // date = [dateFormat('YYYY-mm-dd 00:00:00', getWeekFirstDay()), dateFormat('YYYY-mm-dd 00:00:00', new Date())]

  // date 要随着上一级页面变动
  // 获取url传递过来的date参数
  dateTemp = (getQueryVariable('date') && getQueryVariable('date') !== 'null') ? decodeURIComponent(getQueryVariable('date')).split(',') : []
  date = (getQueryVariable('date') && getQueryVariable('date') !== 'null') ? [dateFormat('YYYY-mm-dd 00:00:00', new Date(this.dateTemp[0])), dateFormat('YYYY-mm-dd 00:00:00', new Date(this.dateTemp[1]))] : ['', '']
  pickerOptions = getPickerOptions()

  // 控制导出数据弹框显示
  dialogVisible = false
  // 导出数据等待页显示state
  exportWait = false
  modalFrom = {
    email: ''
  }

  isDialog(){
    if (!this.date) {
      this.$message.error("请选择有效的统计周期")
    } else if (DateDiff(this.date[1], this.date[0]) > 180) {
      this.$message.error("仅限导出最近180天的数据，请重新选择统计周期")
    } else {
      this.dialogVisible = true
    }
  }

  handleModalCancle() {
    this.exportWait = false
    this.dialogVisible = false

  }

  changeDate(e:Date[]){
    if (this.$route.params.id) {
      this.getFlowStatistics()
    }
  }

  async getFlowStatistics(){
    if (this.$route.params.copyId) {
      return
    }
    let  strategyIds = this?.flowDetail && this?.flowDetail.strategyUnitList.map(item => item.id )
    let {status ,data} =  await getFlowStatistics({
      strategyIds: strategyIds,
        dateStart: this.date ? this.date[0] : dateFormat('YYYY-mm-dd 00:00:00',new Date(new Date().setHours(0, 0, 0, 0) - 30 * 24 * 60 * 60 * 1000)),
        dateEnd: this.date ? this.date[1]  :dateFormat('YYYY-mm-dd 00:00:00',new Date())
       }, true)
    if(status == 200){
      this.FlowStatistics = data?.data
    }
  }

  getFlowStatisticsItem(id:number|undefined,v:string){
    if (this.FlowStatistics && id) {
      let newobj = this.FlowStatistics.filter(item =>{
        return item.id === id
      })
      return newobj[0] && newobj[0][v]

    }else{
      return false
    }
  }

  async getCompanyDetail(){
      let {data} = await getCompanyDetail({},true)
      if(data){
        this.emailInterval = data.data.emailInterval /60 /60
      }
    }

  /**
   * init
   */
  async created(): Promise<void> {
    if(this.$route.path.match(new RegExp('^/strategy/check/[^/]*$'))) {
      this.permission = 'check';
    }
    await getFlowConfig({}, true).then((res) => {
      this.config = res.data.data;
      this.config = getConfigTips(this.config);
    });
    this.getFlowDetail()
    this.getFenqunList();
    this.getSuggestList();
    const that = this;
    this.rules.cname.push({
      trigger: "blur",
      validator: (rule: any, value: any, callback: any) => {
        const cnameList =
                that.flowDetail?.strategyUnitList
                        .filter(
                                (strategy) =>
                                        strategy.frontId !== that.activeStrategyUnit.frontId
                        )
                        .map((strategy) => strategy.cname) || [];
        if (cnameList.indexOf(value) !== -1) {
          callback(new Error("策略器名称不能重复"));
        } else {
          callback();
        }
      },
    });
    window.addEventListener('message', this.getEasyEmailReturn);
    this.getCompanyDetail()

  }

  beforeDestroy() : void {
    window.removeEventListener('message', this.getEasyEmailReturn);
    if (this.$route.fullPath =='/marketing/process/list') {
      store.commit('SET_FLOW', null);
    }
    window.removeEventListener('click', this.choseItem);
  }
  mounted() {
    document.addEventListener(
      "click",
      this.choseItem,
      true
    );
  }

  choseItem(e: any) {
    let emailExpand: any = this.$refs.emailExpand;
    if (emailExpand && !emailExpand.contains(e.target)) {
      this.emailExpandVisible = false;
    }
  }


  async getFlowDetail(){
    if (this.$route.params.id) {
      let params = {
        id: parseInt(this.$route.params.id),
       }
      await getFlowDetail(params, true).then(
        (res) => {
          if (this.$store.state.flow && this.$store.state.flow.id == this.$route.params.id) {
            this.flowDetail = this.$store.state.flow
          }else{
            this.flowDetail = res.data.data;
          }
          if (this.flowDetail && this.flowDetail.type === "TRIGGER_A_FENQUN") {
            for (let rule of this.flowDetail.entryRule.patternFirstDo.rules ||
              []) {
              const match =
                      rule.eventName?.match(new RegExp('(?<=ENTRY_FENQUN_)[0-9]+')) || [];
              if (match.length > 0) {
                rule.fenqunId = parseInt(match[0]);
              }
            }
          }
          this.flowDetail?.strategyUnitList.forEach(strategy => {
            if (strategy.email) {
              strategy.email.content = this.emailToFe(strategy.email.content||'');
            }
          })
          // 编辑状态默认完成
          this.strategyStatus = true;
          this.initCanvas();
        }
      );
    } else if (this.$route.params.copyId) {
      let params = {
        id: parseInt(this.$route.params.copyId),
       }
      await copyFlowDetail(params, true).then(
        (res) => {
          if (this.$store.state.flow && !this.$store.state.flow.id && this.$route.params.copyId) {
            this.flowDetail = this.$store.state.flow
          }else{
            this.flowDetail = res.data.data;
          }
          if (this.flowDetail && this.flowDetail.type === "TRIGGER_A_FENQUN") {
            for (let rule of this.flowDetail.entryRule.patternFirstDo.rules ||
              []) {
              const match =
                rule.eventName?.match(new RegExp('(?<=ENTRY_FENQUN_)[0-9]+')) || [];
              if (match.length > 0) {
                rule.fenqunId = parseInt(match[0]);
              }
            }
          }
          // 编辑状态默认完成
          this.strategyStatus = true;
          this.flowDetail?.strategyUnitList.forEach(strategy => {
            if (strategy.email) {
              strategy.email.content = this.emailToFe(strategy.email.content||'');
            }
          })

          this.initCanvas();
        }
      );
    } else {
      if (this.$store.state.flow && !this.$store.state.flow.id) {
        this.flowDetail = this.$store.state.flow
      }else{
        this.flowDetail = {
          name: "",
          startTime: "2022-02-17 00:00:00",
          endTime: "2922-02-17 00:00:00",
          type: "TRIGGER_A",
          limitType: 2,
          reEnter: {
            unit: "DAY",
            value: 1,
            limit: 1
          },
          entryRule: {
            patternFirstDo: {
              type: "RELATION",
              relation: "OR",
              windowDo: "DO",
              rules: [
                {
                  type: "EVENT",
                  eventName: "",
                  relation: "AND",
                  filters: []
                }
              ]
            }
          },
          audienceRule: {
            type: "RELATION",
            relation: "AND",
            rules: [
              {
                type: "EVENT",
                relation: "AND",
                strictType: "PROPERTY_STRICT",
                filters: [
                  {
                    type: "FILTER",
                    field: "subscribe_status",
                    operator: "EQUAL",
                    value: [
                      "1"
                    ],
                    valueType: "int",
                    associate: 1,
                    controls: "MULTI_INPUT"
                  }
                ]
              },
              {
                type: "RELATION",
                strictType: "ACTION_STRICT",
                relation: "AND",
                rules: []
              }
            ]
          },
          strategyUnitList: [],
          strategyUnitRelation: [],
          daterange: [new Date(new Date().setHours(0, 0, 0, 0) - 30 * 24 * 60 * 60 * 1000),new Date()],
          // intelligentSend : false
        };
      }

      // this.settingVisible = true;
      // 新流程初始化
      this.initCanvas();
    }
    if (this.$route.params.id) {
      this.getFlowStatistics()
    }
    // this.flowDetail?.strategyUnitList.
  }

  getEasyEmailReturn(e: any): void {
    if(e.data.event === 'logout') {
      window.location.href = '/cartsee-new/login';
    }
    if(e.data.event === 'close' || e.data.event === 'save') {
      this.easyEmailSrc = '';
      this.showEasyEmail = false;
    }
    if((e.data.event === 'close' || e.data.event === 'save'|| e.data.event === 'autoSave') && e.data.content && this.activeStrategyUnit.email) {
      this.activeStrategyUnit.email.jsonContent = e.data.jsonContent;
      this.activeStrategyUnit.email.content = e.data.content;
      this.activeStrategyUnit.email.showSubscribeCode = e.data.showSubscribeCode;
      this.activeStrategyUnit.email.couponCode = e.data.couponCode;
      this.activeStrategyUnit.email.baseTemplateId = e.data.baseTemplateId;
      // console.log(e.data.baseTemplateId)
      const easyEmail: any = this.$refs.easyEmail;
      easyEmail?.contentWindow?.postMessage({
        event: 'saveCb',
        message: ''
        // message: dateFormat('HH:MM:SS', new Date()) + ' 已保存'
        }, '*');
    }
  }

  /**
   * 返回
   */
  async back() {
    this.permission === 'check' || await this.$confirm(
      "本次修改的策略器和触发器都不会保存，是否返回？",
      "提示",
      {customClass:'modalOk'}
      );
    this.$router.push("/marketing/process");
  }

  @Watch("flowDetail.limitType", { immediate: true, deep: true })
  setReEnter(newVal: number) {
    if (newVal === 2 && !this.flowDetail?.reEnter) {
      this.flowDetail &&
        (this.flowDetail.reEnter = {
          unit: "DAY",
          value: 1,
          limit: 1,
        });
    }
  }


  /**
   * 获取联系人列表
   */
  getFenqunList(): void {
    getFenqunAvailableList({ currentPage: 1, pageSize: 10000 }).then((res) => {
      this.fenqunList = res.data.data.map((el) => ({
        en: el.id,
        show: el.name,
      }));
    });
  }

  /**
   * 联想列表（用于预加载）
   */
  getSuggestList() {
    ['items','collections','flow_name','strategy_name','campaign_name','subject_content','bounce_type'].forEach(type => {
      Object.keys(this.$store.state.suggestMap).indexOf(type) === -1 &&
      getSuggestList({type}).then(res => {
        store.commit('SET_SUGGEST_MAP', {key: type, value: res.data.data||[]});
      })
    })
  }

  /**
   * 保存并发布
   */
  savePublishDetail() {
    const flowDetailName: any = this.$refs.flowDetailName;
    flowDetailName.validate((valid: boolean, info: any) => {
      if (valid) {
        if (this.flowDetail && this.flowDetail.strategyUnitList.length === 0) {
          this.$message.error("必须设置策略器后才可发布！");
          return;
        }

        const flowDetail: FlowDetailVO = JSON.parse(JSON.stringify(this.flowDetail));
        flowDetail?.strategyUnitList.forEach(strategy => {strategy.email && (strategy.email.content = this.emailToBe(strategy.email?.content||''))})
        flowDetail &&
        savePublishDetail(flowDetail, true).then((res: any) => {
          // 设置是否第一次发布流程
          if (res?.data?.data?.firstFlow) {
            sessionStorage.setItem("isFirstFlow", "1");
          }
          this.$message.success("发布成功！");
          this.$router.push("/marketing/process");
        });
      } else {
        this.$message.error(info.name[0].message);
        return false;
      }
    });
  }

  /**
   * 保存
   */
  saveFlowDetail() {
    const flowDetailName: any = this.$refs.flowDetailName;
    flowDetailName.validate((valid: boolean, info: any) => {
      if (valid) {
        const flowDetail: FlowDetailVO = JSON.parse(JSON.stringify(this.flowDetail));
        flowDetail?.strategyUnitList.forEach(strategy => {strategy.email && (strategy.email.content = this.emailToBe(strategy.email?.content||''))})
        flowDetail &&
        saveFlowDetail(flowDetail, true).then((res: any) => {
          this.$message.success("保存成功！");
          this.$router.push("/marketing/process");
        });
      } else {
        this.$message.error(info.name[0].message);
        return false;
      }
    });
  }

  /**
   * 保存草稿
   */
  saveDraftDetail() {
    const flowDetailName: any = this.$refs.flowDetailName;
    flowDetailName.validate((valid: boolean, info: any) => {
      if (valid) {
        const flowDetail: FlowDetailVO = JSON.parse(JSON.stringify(this.flowDetail));
        flowDetail?.strategyUnitList.forEach(strategy => {strategy.email && (strategy.email.content = this.emailToBe(strategy.email?.content||''))})
        flowDetail &&
          saveDraftDetail(flowDetail, true).then((res: any) => {
            this.$message.success("保存成功！");
            this.$router.push("/marketing/process");
          });
      } else {
        this.$message.error(info.name[0].message);
        return false;
      }
    });
  }

  /**
   * flow类型选择
   */
  flowTypeChange(type: string): void {
    if (!this.flowDetail) {
      return;
    }
    this.flowDetail.type = type;
    if (this.flowDetail.type === "TRIGGER_A") {
      this.flowDetail.entryRule.patternFirstDo = {
        type: "RELATION",
        relation: "OR",
        windowDo: "DO",
        rules: [
          {
            type: "EVENT",
            eventName: "",
            relation: "AND",
            filters: [],
          },
        ],
      };
    } else if (this.flowDetail.type === "TRIGGER_A_FENQUN") {
      this.flowDetail.entryRule.patternFirstDo = {
        type: "RELATION",
        relation: "OR",
        windowDo: "DO",
        rules: [
          {
            type: "EVENT",
            eventName: "",
            relation: "OR",
          },
        ],
      };
      if (this.fenqunList && this.fenqunList.length > 0) {
        const fenqunId = this.fenqunList[0].en;
        this.flowDetail.entryRule.patternFirstDo.rules = [
          {
            type: "EVENT",
            eventName: `ENTRY_FENQUN_${fenqunId}`,
            relation: "OR",
            fenqunId: fenqunId,
          },
        ];
      }
    }
  }

  /**
   * 添加用户群
   */
  AddFenqun(rules: RuleFilterVO[]) {
    rules.push({
      type: "EVENT",
      eventName: "",
      relation: "AND",
    });
  }

  /**
   * 删除用户群
   */
  deleteFenqun(rules: RuleFilterVO[], index: number) {
    rules.splice(index, 1);
  }

  /**
   * 策略器策略类型变化
   */
  strategyTypeChange(activeStrategyUnit: StrategyUnitVO, type: string) {
    if (type === "USER") {
      if (!activeStrategyUnit.userRule) {
        activeStrategyUnit.userRule = JSON.parse(this.userRule);
      }
      activeStrategyUnit.strategyRule = activeStrategyUnit.userRule;
      // 防止后端返回数据有误
      if (!this.activeStrategyUnit.userRule?.window) {
        this.activeStrategyUnit.userRule &&
          (this.activeStrategyUnit.userRule.window = {});
      }
      if (this.activeStrategyUnit.userRule?.rules?.length === 0) {
        this.activeStrategyUnit.userRule.rules = JSON.parse(
          this.userRule
        ).rules;
      }
    } else if (type === "EVENT") {
      if (!activeStrategyUnit.eventRule) {
        activeStrategyUnit.eventRule = JSON.parse(this.eventRule);
      }
      activeStrategyUnit.strategyRule = activeStrategyUnit.eventRule;
      // 防止后端返回数据有误
      if (!this.activeStrategyUnit.eventRule?.window) {
        this.activeStrategyUnit.eventRule &&
          (this.activeStrategyUnit.eventRule.window = {});
      }
      if (this.activeStrategyUnit.eventRule?.rules?.length === 0) {
        this.activeStrategyUnit.eventRule.rules = JSON.parse(
          this.eventRule
        ).rules;
      }
    }
  }

  /**
   * 进入设置/受众用户设置时，点击“取消”按钮，清除非保存的已填写数据
   */
  setCancleAudienceRule() {
    // let flowDetail: any = this.flowDetail;
    // // 受众用户数据剔除, 如长度不大于1则默认
    // flowDetail.audienceRule.rules = flowDetail.audienceRule.rules.map(
    //   (x: any) => {
    //     if (x.strictType === "PROPERTY_STRICT") {
    //       return {
    //         ...x,
    //         filters: x.filters.filter((x: any) => x?.id),
    //       };
    //     } else if (x.strictType === "ACTION_STRICT") {
    //       return {
    //         ...x,
    //         rules: x.rules.filter((x: any) => x?.id),
    //       };
    //     }
    //   }
    // );
    // // 进入条件用户数据剔除
    // flowDetail.entryRule.patternFirstDo = {
    //   ...flowDetail.entryRule.patternFirstDo,
    //   rules: (flowDetail.entryRule.patternFirstDo.rules.some(
    //     (x: any) => !!x?.id
    //   )
    //     ? flowDetail.entryRule.patternFirstDo.rules?.filter((x: any) => x?.id)
    //     : [flowDetail.entryRule.patternFirstDo.rules?.[0]]
    //   ).map((x: any) => {
    //     // 如果长度小于1则是默认值
    //     return {
    //       ...x,
    //       filters:
    //         x.filters?.filter((x: any) => x?.id).length > 1
    //           ? x.filters?.filter((x: any) => x?.id)
    //           : [],
    //     };
    //   }),
    // };
    // this.$nextTick(() => {

      //此处应该不需要默认了。

      this.settingVisible = false;
    //   this.flowDetail = { ...flowDetail };
    // });
  }

  // 设置页面状态的
  setSettingStatus() {
    const flowDetail: any = this.flowDetail;

    if (this.activeTab === 1) {

      if (flowDetail.type === "TRIGGER_A") {
        const excludeOperator = ['ASTRUE', 'ASFALSE', 'HAS', 'HASNOT', 'ALLTIME']; // 剔除必有值项
        const excludeType = ["DYNAMIC", "ABSOLUTE", "ATLAST", "ATLASTBEFFORE", "BETTEN"]; // 验证两个值
        const validateProperty = (x : any) => {
          return !(!x?.field && (!x?.value?.length && !excludeOperator.includes(x?.operator))) && !((!!x?.field && (!excludeType.includes(x?.operator) ? (!!x?.value?.length || excludeOperator.includes(x?.operator)) : (x?.value?.length === 2 && !x?.value?.some((x : any) => typeof x === 'undefined' || x === ""))))) || (!!x?.field && x?.value?.some((x: any) => typeof x === 'undefined' || x === '' || x === null));
        }
        // 用户行为满足 过滤全空事件
        const actionStrict = flowDetail.entryRule.patternFirstDo.rules;
        const actionInvalid = actionStrict.some((x: any) => x.filters.some((x: any) => validateProperty(x)));
        if (actionInvalid) {
          this.$message.error("添加了无效的筛选条件，请重新设置或删除");
          return;
        }
        flowDetail.entryRule.patternFirstDo.rules = actionStrict.filter((x: any) => x?.eventName !== "").map((x: any) => {
          return {
            ...x,
            filters: x.filters.filter((x: any) => !!x.field)
          }
        })
        // 过滤无用的值
        this.flowDetail = flowDetail;
      }

      this.activeTab = 2;

    } else if (this.activeTab === 2) {
      // 用户流程校验提示, 验证未填写完整的数据
      // 用户属性满足
      const propertyStrict = flowDetail.audienceRule.rules.find((x: any) =>x.strictType === "PROPERTY_STRICT");
      const excludeOperator = ['ASTRUE', 'ASFALSE', 'HAS', 'HASNOT', 'ALLTIME']; // 剔除必有值项
      const excludeType = ["DYNAMIC", "ABSOLUTE", "ATLAST", "ATLASTBEFFORE", "BETTEN"]; // 验证两个值
      // 暂时先封装了一个方法
      const validateProperty = (x : any) => {
        return !(!x?.field && (!x?.value?.length && !excludeOperator.includes(x?.operator))) && !((!!x?.field && (!excludeType.includes(x?.operator) ? (!!x?.value?.length || excludeOperator.includes(x?.operator)) : (x?.value?.length === 2 && !x?.value?.some((x : any) => typeof x === 'undefined' || x === ""))))) || (!!x?.field && x?.value?.some((x: any) => typeof x === 'undefined' || x === '' || x === null));
      }
      const propertyInvalid = propertyStrict.filters.some((x: any) => validateProperty(x));
      // 用户行为满足 过滤全空事件
      const actionStrict = flowDetail.audienceRule.rules.find(
        (x: any) => x.strictType === "ACTION_STRICT"
      ).rules;
      // 此处不需要必填
      // const actionInvalid = actionStrict.some((x: any) =>(!x.timeFunction || !x.eventName || !x?.windowDo) && !(!x.timeFunction && !x.eventName && !x?.windowDo)) || actionStrict.filter((x: any) =>!excludeType.includes(x.timeFunction)).some((x: any) =>[...x.filters, x.measure].some((x: any) => validateProperty(x))) || actionStrict.filter((x: any) =>excludeType.includes(x.timeFunction)).some((x: any) =>((!x.eventName || !x?.windowDo || x.timeParams.length < 2) && !(!x.eventName && !x?.windowDo && x.timeParams.length === 2)) || [...x.filters, x.measure].some((x: any) => validateProperty(x)));
      // if (propertyInvalid || actionInvalid) {
      //   this.$message.error("添加了无效的筛选条件，请重新设置或删除");
      //   return;
      // }
      // const propertyOnlyInvalid = !propertyStrict.filters.some((x: any) => excludeOperator.includes(x.operator) || (x.field && x.value?.length));
      // const actionOnlyInvalid = !actionStrict.some((x: any) => x.timeFunction && x.eventName && x?.windowDo);
      // if (propertyOnlyInvalid && actionOnlyInvalid) {
      //   this.$message.error("请至少添加一项用户属性或用户行为筛选条件");
      //   return;
      // }
      // 过滤未填写数据进行提交
      const propertyValidData = propertyStrict.filters.filter((x: any) => !!x.field);
      const actionValidData = actionStrict.filter((x: any) => !!x.eventName).map((x: any) => {
        return {
          ...x,
          filters: x.filters.filter((x: any) => !!x.field),
        }
      });

      const propertyIndex = flowDetail.audienceRule.rules.findIndex((x: any) => x.strictType === "PROPERTY_STRICT");
      const actionIndex = flowDetail.audienceRule.rules.findIndex((x: any) => x.strictType === "ACTION_STRICT");

      flowDetail.audienceRule.rules[propertyIndex].filters = propertyValidData;
      flowDetail.audienceRule.rules[actionIndex].rules = actionValidData;

      this.flowDetail = flowDetail;

      this.activeTab = 2;
      this.strategyStatus = true;
      this.settingVisible = false;
    }
  }

  sendTestEmail() {
    this.$prompt('测试接收邮件', '测试发送', {
      customClass: 'send-email-box',
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPlaceholder: 'test1@email.com,test2@email.com...',
      inputValue: this.$store.state.displayInfo.email || '',
      closeOnClickModal: false,
      inputValidator: (value: any,) => {
        if(value.length > 2000) {
          return "长度不能超过2000个字符";
        }
        const valueArr = value.split(',')
        if(valueArr[valueArr.length-1] === '') {
          valueArr.pop()
        }
        if(value.indexOf(',') === -1) {
          return this.validatorSingle(valueArr[0])
        } else if(valueArr.length  > 10) {
          return '一次性最多支持10个邮箱'
        } else {
          for (let i = 0; i < valueArr.length; i++) {
            let staging = this.validatorSingle(valueArr[i])
            if(String(staging) !== 'true') {
              return staging
            }
          }
          return true
        }
      }
    }).then(({value}: any) => {
      this.activeStrategyUnit.email && sendTestEmail({
        channelType: 0,
        toEmail: value,
        emailContent:{
          ...this.activeStrategyUnit.email,
          content: this.emailToBe(this.activeStrategyUnit.email?.content||'')
        }
      }).then(() => {this.$message.success('邮件已发送，请查收！')});
    }).catch(() => {});
  }
  validatorSingle(value: string) {
      if(!value) {
        return '请输入发件人邮箱地址'
      } else if (value.length > 200) {
        return "单个邮箱长度不能超过200个字符";
      } else if (!(new RegExp("[\\w!#$%&'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\\w](?:[\\w-]*[\\w])?\\.)+[\\w](?:[\\w-]*[\\w])?")).test(value)) {
        return "请输入正确的邮箱地址";
      } else {
        return true;
      }
    }

  formatSubject(subject: string) {
    return subject.replace(
      new RegExp(tagRegStr, 'g'),
      (str: string) => {
        const regArr = str.match(new RegExp(tagRegStr))||[];
        const key = regArr[1];
        const label = tagList.find(item => item.value === key)?.label || key;
        return `<input type="button" class="text-editor-inner-tag-show" value="${label}">`
      }
    )
  }

  saveCompanyTemplate() {
    this.$prompt('模板名称', '另存为模板', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPlaceholder: '',
      closeOnClickModal: false,
      inputValidator: (value: any) => {
        if(!value) {
          return "请输入模板名称";
        }
        return true;
      }
    }).then(({value}: any) => {
      if (!this.activeStrategyUnit.email) {
        return;
      }
      const jsonObj = JSON.parse(this.activeStrategyUnit.email.jsonContent||'{}');
      saveCompanyTemplate({
        title: value,
        imageUrl: '',
        jsonContent: JSON.stringify(jsonObj.content || jsonObj),
        couponCode: this.activeStrategyUnit.email.couponCode,
        showSubscribeCode: this.activeStrategyUnit.email.showSubscribeCode,
        category: "MailEditor"
      })
        .then(() => {this.$message.success('已保存为邮件模板！')})
        .catch((e) => {
          if (e?.handled) {
            return;
          }
          this.$message.success('邮件模板保存失败，请重试')
        })
    }).catch(() => {});
  }
  /**
   * 邮件转义: 用于处理后端数据和前端展示的不同
   */
  emailToBe(str: string) {
    return str.replace(/href-data="/g, 'href="').replace(new RegExp(`<span style="display: none;">products-from-start:([^<]+)</span>.*<span style="display: none;">products-from-end</span>`), '$1')
  }
  emailToFe(str: string) {
    return str.replace(/href="/g, 'href-data="').replace(new RegExp(`(\\{\\{products_from\\|[^\\}]+\\}\\})`), `<span style="display: none;">products-from-start:$1</span><div><div style="overflow: hidden; width: 332px; height: 332px; margin: 0px auto; background: rgb(245, 246, 250);"><img src="/img/no_product.d853f93d.svg" alt="" style="display: block; margin: 68px auto 24px; width: 159px; height: 169px;"></div><p style="margin-top: 5px; width: 332px; opacity: 0.7; font-size: 12px; font-family: PingFangTC-Regular, PingFangTC; font-weight: 400;"> 此处为商品详细信息，包含商品名称，sku数量，规格与商品售价等信息 </p></div><span style="display: none;">products-from-end</span>`)
  }

  templateClick(id: number) {
    this.activeStyleId = id;
    this.showTemplate = true;
    this.showSelectTemplate = false;
    this.$nextTick(() => {
      let emailTemplate : any;
      if (id === 3) {
        emailTemplate = this.$refs.emailTemplate1;
      } else if (id === 4) {
        emailTemplate = this.$refs.emailTemplate2;
      } else if (id === 5) {
        emailTemplate = this.$refs.emailTemplate3;
      } else {
        emailTemplate = this.$refs.emailTemplate;
      }
      // const emailTemplate: any = id === 3 ? this.$refs.emailTemplate1 : this.$refs.emailTemplate;
      emailTemplate.getStyleInfo(id);
    })

  }

  saveTemplate(data: {templateHtml: string, originContent: string}) {
    this.showTemplate = false;
    this.showSelectTemplate = false;
    if (this.activeStrategyUnit.email) {
      this.activeStrategyUnit.email.content = data.templateHtml;
      this.activeStrategyUnit.email.originContent = data.originContent;
    }
  }

  backTemplate() {
    this.showTemplate = false;
    if(this.activeStrategyUnit.email?.originContent) {
      this.activeStyleId = JSON.parse(this.activeStrategyUnit.email.originContent||'{}').id;
    }
  }


  iframeLoad() {
    const easyEmail:any = this.$refs.easyEmail;
    if(this.activeStrategyUnit.email) {
      easyEmail?.contentWindow.postMessage({
        ...this.activeStrategyUnit.email,
        event: 'initialEmailData'
      },'*');
    }
  }

  /**
   * 邮件编辑
   */
  emailEdit(hasContent: boolean) {
    if(this.activeStrategyUnit.email && !this.activeStrategyUnit.email.originContent) {
      if(this.activeStrategyUnit.email.jsonContent) {
        this.easyEmailSrc = process.env.VUE_APP_DOMAIN + '/easy-email/editor?type=2&token=' + getToken();
        this.showEasyEmail = true;
      } else {
        this.easyEmailSrc = process.env.VUE_APP_DOMAIN + '/easy-email/list?token=' + getToken()+'&modular=flow';
        this.showEasyEmail = true;
      }
    } else if (hasContent) {
      this.showTemplate = true;
      this.$nextTick(() => {
        let emailTemplate : any;
        if (this.activeStyleId === 3) {
          emailTemplate = this.$refs.emailTemplate1;
        } else if (this.activeStyleId === 4) {
          emailTemplate = this.$refs.emailTemplate2;
        } else if (this.activeStyleId === 5) {
          emailTemplate = this.$refs.emailTemplate3;
        } else {
          emailTemplate = this.$refs.emailTemplate;
        }
        // const emailTemplate: any = this.activeStyleId === 3 ? this.$refs.emailTemplate1 : this.$refs.emailTemplate;
        emailTemplate.reShow(this.activeStrategyUnit.email?.originContent || '');
      })
    } else {
      this.showSelectTemplate = true;
    }
  }

  // todo 以下方法为画布方法，等待画布组件封装
  // 基础尺寸参数
  // 根元素 width="546" height="162"
  public rootWidth = 546;
  public rootHeight = 162;
  // 子元素 width="260" height="348" padding: 0 20px
  public nodeWidth = 260;
  public nodePadding = 20;
  public nodeHeight = 348;
  // 线高 140（行间距） + 15 * 2（藏线）
  public lineHeight = 140;
  public lineHide = 15;

  // 以下为画布渲染对象
  // 渲染节点对象(含根元素)
  public nodeMap!: { [prop: string]: any };
  // 层级节点顺序信息(含根元素)
  public layerInfo: any = {};
  // 渲染连线数组(含根元素)
  public lineLayer: any[] = [];
  // 最大行内节点数
  public maxRow = 1;
  // 画布总宽 Math.max(546 + 50 * 2, (260 + 20 * 2) * maxColumnNum + 50 * 2)
  public maxWidth = 546 + 50 * 2;
  // 画布总长 100 + 162 + (348 + 140) * maxLineNum
  public maxHeight = 100 + 162;

  public newParent = 1;
  public editIndex!: number;

  /**
   * 新增节点
   */
  addNode(parent: number) {
    if (!this.flowDetail) {
      return;
    }
    // 生成新id
    const nodeList = this.flowDetail.strategyUnitList
      .map((el: any) => el.frontId)
      .sort((a: number, b: number) => b - a);
    let newNodeId = 100;
    if (nodeList.length > 0) {
      newNodeId = Math.max(nodeList[0], 99) + 1;
    }

    this.activeStrategyUnit = {
      frontId: newNodeId,
      editable: true,
      cname: "",
      style: "USER",
      strategyChannel: 'Email',
      delayConfig: {
        value: 15,
        unit: "MINUTE",
        sendTiming: "DELAY",
        opSend: "SEND",
      },
      sms: { //短信模版
        content: "",
        showShortUrl: true
      },
      strategyRule: JSON.parse(this.userRule),
      userRule: JSON.parse(this.userRule),
      eventRule: JSON.parse(this.eventRule),
      email: {
        subject: '',  //主题
        content: '',  //内容
        preheader:'',
        templateId: 7,  //模板ID
        originContent: ''
      },
      intelligentSend:false
    };
    this.strategyDetailStatus = "add";
    this.newParent = parent;
    this.activeStyleId = JSON.parse(this.activeStrategyUnit?.email?.originContent||'{}').id||1;
  }

  /**
   * 删除节点
   */
  async deleteNode(nodeId: number) {
    if (!this.flowDetail) {
      return;
    }
    await this.$confirm(
      "确定删除该节点和所有子节点吗？删除后无法恢复！",
      "确定删除吗？",
      {customClass:'modalOk'}
    );
    // 找到所有子节点
    let childList: number[] = [];
    childList = this.getChildNode(childList, this.nodeMap, nodeId);
    this.flowDetail.strategyUnitList = this.flowDetail.strategyUnitList.filter(
      (strategyUnit: any) => !childList.includes(strategyUnit.frontId)
    );
    this.flowDetail.strategyUnitRelation =
      this.flowDetail.strategyUnitRelation.filter((relation: any) => {
        if (childList.includes(relation.from)) {
          return false;
        } else {
          // 删除作为子节点的连线
          for (let child of childList) {
            if (relation.to.includes(child)) {
              relation.to.splice(relation.to.indexOf(child), 1);
            }
          }
          return relation.to.length !== 0;
        }
      });
    // 渲染
    this.initCanvas();
    this.$message.success("删除成功！");
  }


  /**
   * 编辑节点
   */
  editNode(activeStrategyUnit: StrategyUnitVO, index: number) {
    this.activeStrategyUnit = JSON.parse(JSON.stringify(activeStrategyUnit));
    // 短信通道老数据兼容
    if(!this.activeStrategyUnit.strategyChannel) {
      Vue.set(this.activeStrategyUnit, 'strategyChannel', 'Email')
    }
    if(!this.activeStrategyUnit.sms) {
      Vue.set(this.activeStrategyUnit, 'sms', {
        content: "",
        showShortUrl: true
      })
    }
    if(!this.activeStrategyUnit.email) {
      Vue.set(this.activeStrategyUnit, 'email', {
        subject: '',  //主题
        content: '',  //内容
        preheader:'',
        templateId: 7,  //模板ID
        originContent: ''
      })
    }
    if (this.activeStrategyUnit.style === "USER") {
      this.activeStrategyUnit.userRule = this.activeStrategyUnit.strategyRule;
    } else if (this.activeStrategyUnit.style === "EVENT") {
      this.activeStrategyUnit.eventRule = this.activeStrategyUnit.strategyRule;
    }
    // 触发一次类型变化
    this.strategyTypeChange(
      this.activeStrategyUnit,
      this.activeStrategyUnit.style || "USER"
    );
    this.strategyDetailStatus = "edit";
    this.editIndex = index;
    this.activeStyleId = JSON.parse(this.activeStrategyUnit?.email?.originContent||'{}').id||1;
  }

  editDetailedNode(activeStrategyUnit: StrategyUnitVO, index: number){
    store.commit('SET_FLOW', this.flowDetail);
    this.$route.params.id && this.$router.push({
      path:`/marketing/process/detailed/${this.$route.params.id}?date=${encodeURIComponent(this.date)}`,
      query: {
        strategyChannel:activeStrategyUnit.strategyChannel,
        cname:activeStrategyUnit.cname,
        id: activeStrategyUnit?.id?.toString(),
       }
      })
    }

  /**
   * 关闭节点
   */
  async closeNode() {
    this.permission === 'check' || await this.$confirm(
      "确定关闭策略器吗？当前编辑内容不会被保存！",
      "确定关闭吗？",
      {customClass:'modalOk'});
    this.strategyDetailStatus = "";
  }

  /**
   * 保存节点
   */
  saveNode() {
    if (!this.flowDetail) {
      return;
    }

    const activeStrategyUnit: any = this.$refs.activeStrategyUnit;
    let res = false;
    activeStrategyUnit.validate((valid: boolean) => {
      return (res = valid);
    });

    if (!res) {
      // 增加策略器名称提交焦点事件
      if (!activeStrategyUnit.cname) {
        this.$nextTick(() => {
          const activeStrategyUnitCNameEl: any =
            this.$refs.activeStrategyUnitCName;
          activeStrategyUnitCNameEl.focus();
        });
      }
      return;
    }

    // 筛选条件规则校验
    if (this.activeStrategyUnit.style === 'USER') {
        // 用户流程校验提示, 验证未填写完整的数据
        // 用户属性满足
        const strategyRules : any = this.activeStrategyUnit.strategyRule;
        const propertyStrict = strategyRules.rules.find((x: any) =>x.strictType === "PROPERTY_STRICT");
        const excludeOperator = ['ASTRUE', 'ASFALSE', 'HAS', 'HASNOT', 'ALLTIME', '']; // 剔除必有值项
        const excludeType = ["DYNAMIC", "ABSOLUTE", "ATLAST", "ATLASTBEFFORE", "BETTEN"]; // 验证两个值
        // 暂时先封装了一个方法
        const validateProperty = (x : any) => {
          return !(!x?.field && (!x?.value?.length && !excludeOperator.includes(x?.operator))) && !((!!x?.field && (!excludeType.includes(x?.operator) ? (!!x?.value?.length || excludeOperator.includes(x?.operator)) : (x?.value?.length === 2 && !x?.value?.some((x : any) => typeof x === 'undefined' || x === ""))))) || (!!x?.field && x?.value?.some((x: any) => typeof x === 'undefined' || x === '' || x === null));
        }
        const propertyInvalid = propertyStrict.filters.some((x: any) => validateProperty(x));
        // 用户行为满足 过滤全空事件
        const actionStrict = strategyRules.rules.find(
          (x: any) => x.strictType === "ACTION_STRICT"
        ).rules;
        // const actionInvalid = actionStrict.some((x: any) =>(!x.timeFunction || !x.eventName || !x?.windowDo) && !(!x.timeFunction && !x.eventName && !x?.windowDo)) || actionStrict.filter((x: any) =>!excludeType.includes(x.timeFunction)).some((x: any) =>[...x.filters, x.measure].some((x: any) => validateProperty(x))) || actionStrict.filter((x: any) =>excludeType.includes(x.timeFunction)).some((x: any) =>((!x.eventName || !x?.windowDo || x.timeParams.length < 2) && !(!x.eventName && !x?.windowDo && x.timeParams.length === 2)) || [...x.filters, x.measure].some((x: any) => validateProperty(x)));
        // if (propertyInvalid || actionInvalid) {
        //   this.$message.error("添加了无效的筛选条件，请重新设置或删除");
        //   return;
        // }
        // 检测是否有有效值 属性条件 2选一
        // const propertyOnlyInvalid = !propertyStrict.filters.some((x: any) => excludeOperator.includes(x.operator) || (x.field && x.value?.length));
        // const actionOnlyInvalid = !actionStrict.some((x: any) => x.timeFunction && x.eventName && x?.windowDo);
        // if (propertyOnlyInvalid && actionOnlyInvalid) {
        //   this.$message.error("请至少添加一项用户属性或用户行为筛选条件");
        //   return;
        // }

        // 过滤未填写数据进行提交
        const propertyValidData = propertyStrict.filters.filter((x: any) => excludeOperator.includes(x.operator) || ((x.field && x.value.length)));
        const actionValidData = actionStrict.filter((x: any) => x.timeFunction || x.eventName || x?.windowDo).map((x: any) => {
          return {
            ...x,
            filters: x.filters.filter((x: any) => !!x.field),
          }
        });

        const propertyIndex = strategyRules.rules.findIndex((x: any) => x.strictType === "PROPERTY_STRICT");
        const actionIndex = strategyRules.rules.findIndex((x: any) => x.strictType === "ACTION_STRICT");

        strategyRules.rules[propertyIndex].filters = propertyValidData;
        strategyRules.rules[actionIndex].rules = actionValidData;

        this.activeStrategyUnit.strategyRule = strategyRules;

    } else {
      // 流程校验提示 验证未填写完整的数据
      const activeStrategyUnit : any = this.activeStrategyUnit;
      const excludeOperator = ['ASTRUE', 'ASFALSE', 'HAS', 'HASNOT', 'ALLTIME']; // 剔除必有值项
      const excludeType = ["DYNAMIC", "ABSOLUTE", "ATLAST", "ATLASTBEFFORE", "BETTEN"]; // 验证两个值
      // 暂时先封装了一个方法
      const validateProperty = (x : any) => {
        return !(!x?.field && (!x?.value?.length && !excludeOperator.includes(x?.operator))) && !((!!x?.field && (!excludeType.includes(x?.operator) ? (!!x?.value?.length || excludeOperator.includes(x?.operator)) : (x?.value?.length === 2 && !x?.value?.some((x : any) => typeof x === 'undefined' || x === ""))))) || (!!x?.field && x?.value?.some((x: any) => typeof x === 'undefined' || x === '' || x === null));
      }
      // 用户行为满足 过滤全空事件
      const actionStrict = activeStrategyUnit.eventRule.rules;
      const actionInvalid = actionStrict.some((x: any) => x.filters.some((x: any) => validateProperty(x)));
      if (actionInvalid) {
        this.$message.error("添加了无效的筛选条件，请重新设置或删除");
        return;
      }

      // 过滤掉无效属性
      activeStrategyUnit.eventRule.rules = actionStrict.map((x : any) => {
        return {
          ...x,
          filters: x.filters.filter((x: any) => !!x.field),
        }
      });

      this.activeStrategyUnit = activeStrategyUnit;

    }

    if (this.activeStrategyUnit.strategyChannel === 'Email' && this.activeStrategyUnit.delayConfig?.sendTiming !== 'NOT') {
      if(!this.activeStrategyUnit.email?.subject) {
        this.$message.error("邮件主题不能为空");
        const subjectInput: any =
                this.$refs.subjectInput;
        subjectInput.focus();
        return;
      }
      if(!this.activeStrategyUnit.email?.content) {
        this.$message.error("邮件模板不能为空");
        return;
      }
    }
    if (this.activeStrategyUnit.strategyChannel === 'Sms' && this.activeStrategyUnit.delayConfig?.sendTiming !== 'NOT') {
      if(!this.activeStrategyUnit.sms?.content) {
        this.$message.error("短信内容不能为空");
        return;
      }
    }


    if (
      this.strategyDetailStatus === "add" &&
      this.activeStrategyUnit.frontId !== undefined
    ) {
      // 生成新节点
      this.flowDetail.strategyUnitList.push({ ...this.activeStrategyUnit });

      // 生成新连线
      let hasRelation = false;
      for (let item of this.flowDetail.strategyUnitRelation) {
        if (item.from === this.newParent) {
          item.to.push(this.activeStrategyUnit.frontId);
          hasRelation = true;
        }
      }
      if (!hasRelation) {
        this.flowDetail.strategyUnitRelation.push({
          from: this.newParent,
          to: [this.activeStrategyUnit.frontId],
        });
      }
      // 渲染
      this.initCanvas();
    }
    if (this.strategyDetailStatus === "edit") {
      this.flowDetail.strategyUnitList[this.editIndex] =
        this.activeStrategyUnit;
    }
    this.strategyDetailStatus = "";
  }

  /**
   * 获取子节点
   */
  getChildNode(childList: number[], nodeMap: any, nodeId: number): number[] {
    if (!childList.includes(nodeId)) {
      childList.push(nodeId);
    }
    for (let toItem of nodeMap[nodeId].to || []) {
      this.getChildNode(childList, nodeMap, toItem);
    }
    return childList;
  }

  /**
   * 画布渲染方程
   */
  initCanvas() {
    if (!this.flowDetail) {
      return;
    }
    this.lineLayer = [];
    this.layerInfo = {};
    // 初始化渲染节点对象
    this.nodeMap = this.getNodeMap(this.flowDetail.strategyUnitRelation);
    // 节点顺序重排
    this.layerInfo = this.rearrange(this.layerInfo, this.nodeMap, 1, 0);
    // 计算节点位置关系
    this.clacPosition();
  }

  /**
   * 渲染节点对象
   */
  getNodeMap(strategy_unit_relation: any) {
    // {[node: string]: {}}
    let nodeMap: { [prop: string]: any } = {};
    if (strategy_unit_relation.length === 0) {
      return { 1: { layer: 0, to: [] } };
    }
    for (let item of strategy_unit_relation) {
      // to有节点
      let hasToNode = false;
      // to节点层列表
      const toLayerList = [];
      for (let toItem of item.to) {
        if (nodeMap[toItem]) {
          hasToNode = true;
          toLayerList.push(nodeMap[toItem].layer);
        }
      }
      if (hasToNode) {
        const maxToLayer = Math.max(...toLayerList);
        // from 初始化
        if (!nodeMap[item.from]) {
          nodeMap[item.from] = { layer: 0, to: item.to };
        } else {
          nodeMap[item.from].to = Array.from(
            new Set([...item.to, ...(nodeMap[item.from].to || [])])
          );
        }
        if (maxToLayer >= nodeMap[item.from]?.layer + 1) {
          // to有节点、max(to)大于等于(from + 1)||0，from为(max(to) - 1)层节点，to进行层递归+1
          nodeMap[item.from].layer = maxToLayer - 1;

          for (let toItem of nodeMap[item.from].to) {
            this.toRecursion(toItem, nodeMap, nodeMap[item.from].layer + 1);
          }
        } else {
          // 如to有节点、max(to)小于(from + 1)||0，from不变，to进行层递归+1
          for (let toItem of nodeMap[item.from].to) {
            this.toRecursion(toItem, nodeMap, nodeMap[item.from]?.layer + 1);
          }
        }
      } else {
        if (nodeMap[item.from]) {
          // from有节点、to没有节点: from不变，to为(from + 1)层节点
          nodeMap[item.from].to = Array.from(
            new Set([...item.to, ...(nodeMap[item.from].to || [])])
          );
          for (let toItem of item.to) {
            nodeMap[toItem] = { layer: nodeMap[item.from].layer + 1 };
          }
        } else {
          // from没有节点、to没有节点：from为0层节点，to为1层节点
          nodeMap[item.from] = { layer: 0, to: item.to };
          for (let toItem of item.to) {
            nodeMap[toItem] = { layer: 1 };
          }
        }
      }
    }
    return nodeMap;
  }

  /**
   * 子节点递归层级变化
   */
  toRecursion(toItem: number, dataMap: any, layer: number) {
    dataMap[toItem] = dataMap[toItem] || {};
    dataMap[toItem].layer = layer;
    for (let childItem of dataMap[toItem].to || []) {
      this.toRecursion(childItem, dataMap, layer + 1);
    }
  }

  /**
   * 节点顺序重排
   */
  rearrange(layerInfo: any, nodeMap: any, nodeId = 1, layerIndex = 0) {
    layerInfo[layerIndex] = layerInfo[layerIndex] || [];
    if (!layerInfo[layerIndex].includes(nodeId)) {
      layerInfo[layerIndex].push(nodeId);
    }
    for (let toItem of nodeMap[nodeId].to || []) {
      this.rearrange(layerInfo, nodeMap, toItem, nodeMap[nodeId].layer + 1);
    }
    return layerInfo;
  }

  /**
   * 计算节点渲染位置关系
   */
  clacPosition() {
    const canvasPadding = 50;
    // 确定画布长宽
    this.maxRow = Math.max(
      ...Object.keys(this.layerInfo).map((key) => this.layerInfo[key].length)
    );
    this.maxWidth = Math.max(
      this.rootWidth + canvasPadding * 2,
      (this.nodeWidth + this.nodePadding * 2) * this.maxRow + canvasPadding * 2
    );
    this.maxHeight =
      canvasPadding * 2 +
      this.rootHeight +
      (this.nodeHeight + this.lineHeight) *
        Math.max(...Object.keys(this.layerInfo).map((key) => parseInt(key)));

    const middleNodeX = this.maxWidth / 2 - this.nodeWidth / 2;
    for (let key of Object.keys(this.layerInfo)) {
      const nodeList = this.layerInfo[key];
      const rowLength = nodeList.length;
      for (let [index, nodeId] of nodeList.entries()) {
        const node = this.nodeMap[nodeId];
        node.X =
          (index - (rowLength - 1) / 2) *
            (this.nodeWidth + 2 * this.nodePadding) +
          middleNodeX;
        if (key === "0") {
          node.Y = this.rootHeight + canvasPadding;
        } else {
          node.Y =
            (this.lineHeight + this.nodeHeight) * parseInt(key) -
            this.nodeHeight +
            this.rootHeight;
        }

        for (let toItem of node.to || []) {
          const toIndex = this.layerInfo[parseInt(key) + 1].indexOf(toItem);
          const toRowLength = this.layerInfo[parseInt(key) + 1].length;
          const toX =
            (toIndex - (toRowLength - 1) / 2) *
              (this.nodeWidth + 2 * this.nodePadding) +
            middleNodeX;
          if (key === "0") {
            const toY =
              (this.lineHeight + this.nodeHeight) * (parseInt(key) + 1) -
              this.nodeHeight +
              this.rootHeight;
            this.lineLayer.push({
              name: `line-${nodeId}-${toItem}`,
              from: nodeId,
              to: toItem,
              X1: node.X + this.nodeWidth / 2,
              Y1: node.Y - this.lineHide,
              X2: node.X + this.nodeWidth / 2,
              Y2: (node.Y + toY) / 2,
              X3: toX + this.nodeWidth / 2,
              Y3: (node.Y + toY) / 2,
              X4: toX + this.nodeWidth / 2,
              Y4: toY + this.lineHide,
            });
          } else {
            this.lineLayer.push({
              name: `line-${nodeId}-${toItem}`,
              from: nodeId,
              to: toItem,
              // 线方程点坐标(x1，y1 - lineHide)(x1, y1 + lineHeight/2)(x2, y1 + lineHeight/2)(x2, y1 + lineHeight + lineHide)
              X1: node.X + this.nodeWidth / 2,
              Y1: node.Y - this.lineHide + this.nodeHeight,
              X2: node.X + this.nodeWidth / 2,
              Y2: node.Y + this.lineHeight / 2 + this.nodeHeight,
              X3: toX + this.nodeWidth / 2,
              Y3: node.Y + this.lineHeight / 2 + this.nodeHeight,
              X4: toX + this.nodeWidth / 2,
              Y4: node.Y + this.lineHeight + this.lineHide + this.nodeHeight,
            });
          }
        }
      }
    }
  }

}
